import colors from 'theme/colors'
import css from 'styled-jsx/css'

const duration = 120

export default css `
label {
  display: flex;
  flex-direction: row;
  align-items: center;
}
label > :global(*:first-child) {
margin-left: 1rem;
}
`
